import React, { Fragment } from "react";
import WindermereHeaderSection from "../components/WindermereHeaderSection";
import Head from "../components/Head";
import { META } from "../utils/constants";
import { ContentWrapper } from "../style/shared";

/* stylelint-enable */

export default ({ data }) => {
  const { clients, events, mentions, articles } = data;

  return (
    <ContentWrapper>
      <Head {...META.profile} image={META.common.image} />
      <WindermereHeaderSection content={() => <Fragment></Fragment>} />
    </ContentWrapper>
  );
};

export const windermereQuery = graphql`
  query windermereQuery {
    clients: allClientsJson {
      edges {
        client: node {
          name
          url
        }
      }
    }
    events: allEventsJson {
      edges {
        event: node {
          year
          position
          company
        }
      }
    }
    mentions: allMentionsJson {
      edges {
        mention: node {
          name
          url
        }
      }
    }
    articles: allArticlesJson {
      edges {
        article: node {
          name
          url
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/windermere.js